// src/components/SolutionSettings.jsx
import React from "react";
import "../styles/SolutionSettings.css";

const SolutionSettings = ({
  availableTolerances,
  selectedTolerance,
  availableSolutionTypes,
  selectedSolutionType,
  onSettingsChange,
  loading,
}) => {
  const handleToleranceClick = (tolerance) => {
    if (availableTolerances.includes(tolerance)) {
      onSettingsChange(tolerance, selectedSolutionType);
    }
  };

  const handleTypeClick = (type) => {
    if (availableSolutionTypes.includes(type)) {
      onSettingsChange(selectedTolerance, type);
    }
  };

  return (
    <div className="solution-settings-container">
      <div className="solution-tolerance-selector">
        <span className="setting-label">Solution Level:</span>
        <div className="tolerance-options">
          {["Solution", "Low-Solution", "No Solution"].map((option) => {
            const isAllowed = availableTolerances.includes(option);
            return (
              <button
                key={option}
                className={`tolerance-option ${
                  selectedTolerance === option ? "active" : ""
                }`}
                onClick={() => handleToleranceClick(option)}
                disabled={!isAllowed || loading}
                title={
                  !isAllowed
                    ? "This level is not available for this course"
                    : ""
                }
              >
                {option.replace("-", " ")}
              </button>
            );
          })}
        </div>
      </div>
      {availableSolutionTypes.length > 0 && (
        <div className="solution-type-selector">
          <span className="setting-label">Output Style:</span>
          <div className="type-options">
            {["step-by-step", "concise"].map((option) => {
              const isSupported = availableSolutionTypes.includes(option);
              return (
                <button
                  key={option}
                  className={`type-option ${
                    selectedSolutionType === option ? "active" : ""
                  }`}
                  onClick={() => handleTypeClick(option)}
                  disabled={!isSupported || loading}
                  title={
                    !isSupported
                      ? "This type is not available for this course"
                      : ""
                  }
                >
                  {option.charAt(0).toUpperCase() + option.slice(1)}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default SolutionSettings;
